import { Component, Input } from "@angular/core";
import { ProductAttributes } from "@models/product.model";

@Component({
    selector: "app-feature-product",
    templateUrl: "./feature-product.component.html",
    styleUrl: "./feature-product.component.scss",
    standalone: false,
})
export class FeatureProductComponent {
    @Input() featuredProducts: ProductAttributes[] = [];
}
